<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { pageByPath } from '@/data/registry'
import ProTablePage from '@/components/pro/ProTablePage.vue'
import LoginView from './auth/LoginView.vue'
import DashboardView from './business/DashboardView.vue'
import UsersView from './business/UsersView.vue'
import MedicationPlansView from './business/MedicationPlansView.vue'
import HealthMonitoringView from './business/HealthMonitoringView.vue'
import DrugsView from './business/DrugsView.vue'
import AssetsView from './business/AssetsView.vue'
import AnalyticsView from './business/AnalyticsView.vue'
import DecorationView from './business/DecorationView.vue'
import GeneralSettingsView from './settings/GeneralSettingsView.vue'
import OperationsView from './settings/OperationsView.vue'
import ProfileView from './settings/ProfileView.vue'
import StateView from './StateView.vue'

const route = useRoute()
const page = computed(() => pageByPath(route.path))

/**
 * Every route resolves to a concrete Vue component. Table-oriented pages use
 * the same typed page definition and ProTablePage, while dashboards, editors,
 * grids and settings pages keep purpose-built interaction surfaces.
 */
const special = computed(() => {
  switch (page.value?.id) {
    case 'login': return LoginView
    case 'dashboard': return DashboardView
    case 'users': return UsersView
    case 'medication-plans': return MedicationPlansView
    case 'health-monitoring': return HealthMonitoringView
    case 'drugs': return DrugsView
    case 'analytics': return AnalyticsView
    case 'assets': return AssetsView
    case 'decoration': return DecorationView
    case 'general-settings': return GeneralSettingsView
    case 'operations': return OperationsView
    case 'profile': return ProfileView
    case 'forbidden':
    case 'not-found':
    case 'server-error':
    case 'maintenance':
    case 'offline':
      return StateView
    default:
      return null
  }
})
</script>

<template>
  <div class="page">
    <component
      :is="special"
      v-if="special"
      v-bind="page?.kind === 'state' ? { kind: page?.id, unknownPath: route.fullPath } : {}"
    />
    <ProTablePage v-else-if="page" :key="page.id" :definition="page" />
    <StateView v-else kind="not-found" :unknown-path="route.fullPath" />
  </div>
</template>
